import { defineStore } from 'pinia'
import { TabData } from '@/api/Models/AppTabs'

interface TState {
  themeType: number
  collegeId: string
  tabOptions: TabData[]
  allTabOptions: TabData[]
}

export const useUsersStore = defineStore('users', {
  state: (): TState => ({
    themeType: 0,
    collegeId: '-1',
    tabOptions: [] as TabData[],
    allTabOptions: [] as TabData[]
  }),
  actions: {
    setThemeType(themeType: number) {
      this.themeType = themeType
    },
    setCollegeId(collegeId: string) {
      this.collegeId = collegeId
    },
    setTabOptions(tabOptions: TabData[]) {
      this.tabOptions = tabOptions
    },
    setAllTabOptions(allTabOptions: TabData[]) {
      this.allTabOptions = allTabOptions
    },
    // 添加一个用于重置状态的 action
    resetState() {
      this.themeType = 0
      this.collegeId = '-1'
      this.tabOptions = []
      this.allTabOptions = []
    }
  },
  persist: true
})
